<template>
  <v-dialog
    v-model="dialog"
    max-width="750"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
              {{ $t('family_card.turn_on.header') }}
            </h2>
          </v-flex>
          <v-flex xs2>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <p class="f-1">
          {{ $t('family_card.turn_on.title') }}
        </p>
        <v-textarea
          v-model="note"
          v-validate="validationRules.get('regular_field')"
          :error-messages="errors.collect('regular_field')"
          data-vv-name="regular_field"
          :label="$t('label.text')"
          :data-vv-as="$t('label.text')"
        />
        <h4 class="display-1 my-3">
          {{ $t('family_card.turn_on.description') }}
        </h4>
        <v-layout
          :wrap="mobileScreen"
          :class="[{ 'mb-2': mobileScreen }]"
        >
          <v-flex
            md4
            sm5
            xs12
          >
            <span class="fw-600">{{ $t('family_card.base_data.status') | addColons }}</span>
          </v-flex>
          <v-flex
            md8
            sm7
            xs12
          >
            {{ preStatusParent }}
          </v-flex>
        </v-layout>
        <v-layout
          v-if="subStatus"
          :wrap="mobileScreen"
          :class="[{ 'mb-2': mobileScreen }]"
        >
          <v-flex
            md4
            sm5
            xs12
          >
            <span class="fw-600">{{ $t('family_card.base_data.sub_status') | addColons }}</span>
          </v-flex>
          <v-flex
            md8
            sm7
            xs12
          >
            {{ subStatus }}
          </v-flex>
        </v-layout>
        <v-layout :wrap="mobileScreen">
          <v-flex
            md4
            sm5
            xs12
          >
            <span class="fw-600">{{ $t('family_card.volunteers.main') | addColons }}</span>
          </v-flex>
          <v-flex
            md8
            sm7
            xs12
          >
            {{ primaryVolunteer }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-4']"
          >
            <a @click="canceled()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :disabled="isDisabled"
              :loading="loading"
              @click="sendAnswer"
            >
              {{ $t('buttons.send') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validationRules from '@/constants/validationRules';
import filters from '@/constants/filters';

export default {
    name: 'TurnOnModal',
    filters: {
        ...filters
    },
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        familyId: {
            required: true
        }
    },
    data () {
        return {
            validationRules,
            dialog: false,
            note: '',
            loading: false
        };
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        preStatusParent () {
            if (this.$store.getters['family/getFamily'].pre_exclusion_status) {
                if (this.$store.getters['family/getFamily'].pre_exclusion_status.parent) {
                    return this.$store.getters['family/getFamily'].pre_exclusion_status.parent.description;
                }
                return this.$store.getters['family/getFamily'].pre_exclusion_status.description;
            }
            return '';
        },
        subStatus () {
            if (
                this.$store.getters['family/getFamily'].pre_exclusion_status &&
        this.$store.getters['family/getFamily'].pre_exclusion_status.parent != null
            ) {
                return this.$store.getters['family/getFamily'].pre_exclusion_status.description;
            }
            return '';
        },
        primaryVolunteer () {
            if (this.$store.getters['family/getFamily'].primary_volunteer) {
                return this.$store.getters['family/getFamily'].primary_volunteer.full_name;
            }
            return this.$t('list.none');
        },
        isDisabled () {
            return this.note.length < 1 || this.$validator.errors.count() > 0;
        }
    },
    watch: {
        visible (val) {
            this.dialog = val;
        },
        dialog () {
            if (!this.dialog) {
                this.clearForm();
                this.$emit('close', false);
            }
        }
    },
    methods: {
        closeDialog () {
            this.dialog = false;
            this.$emit('close', false);
        },
        clearForm () {
            this.note = '';
        },
        canceled () {
            this.closeDialog();
        },
        sendAnswer () {
            this.loading = true;
            this.$store
                .dispatch('family/turnOnFamily', { id: this.familyId, data: this.note })
                .then(({ data }) => {
                    this.$store.dispatch('sheet/getSheetPermissions', this.familyId);
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.loading = false;
                    this.closeDialog();
                });
        }
    }
};
</script>

<style scoped></style>
